import "core-js/modules/es.array.push.js";
export default {
  props: {
    shown: false,
    text: String,
    title: String,
    routeName: String
  },
  methods: {
    redirect: function redirect() {
      this.$router.push({
        name: this.routeName
      });
    }
  }
};